<script>
	import SkyList from 'sky-list';
	import SkySearchMixin from 'sky-search/sky-search.mixin';

	const preferences = {
		api: '/umbraco/api/EmployeeApi/Search',
		pagination: true,
	};

	const parameters = {
		limit: 9999,
		keywords: '',
		subject: '',
		title: '',
	};

	export default {
		name: 'ge-list',
		props: {
			filter: Object,
		},
		mixins: [SkySearchMixin],
		data() {
			return {
				list: new SkyList(preferences, parameters),
				keywords: '',
				subject: '',
				title: '',
			};
		},
		computed: {
			showMessage() {
				return this.keywords.length > 1 || this.subject || this.title;
			},
		},
		created() {
			/**
			 * Populate keywords prop from list if the prop should
			 * have intial value (from url query params for instance)
			 */
			this.keywords = this.list.params.keywords;

			this.filter.subjectSelect.forEach((subject) => {
				if (subject.selected) {
					this.subject = subject.value;
				}
			});

			this.filter.titleSelect.forEach((title) => {
				if (title.selected) {
					this.title = title.value;
				}
			});

			this.list.update();
		},
		watch: {
			keywords() {
				// Keep list keyword param in sync
				this.list.params.keywords = this.keywords;

				if (this.keywords.length > 1) {
					this.update();
				} else {
					this.list.reset();
				}
			},
			subject() {
				// Keep list subject param in sync
				this.list.params.subject = this.subject;
				this.update();
			},
			title() {
				// Keep list title param in sync
				this.list.params.title = this.title;
				this.update();
			},
		},
		methods: {
			update() {
				this.list.update();
			},
			subjectString(array) {
				return array.reduce((acc, cur, index, _array) => {
					if (index === 0) {
						acc = `${cur}`;
					} else {
						if (index === _array.length - 1) {
							acc = `${acc} og ${cur}`;
						}

						if (index < _array.length - 1) {
							acc = `${acc}, ${cur}`;
						}
					}

					return acc;
				}, '');
			},
		},
	};
</script>

<style src="./ge-list.scss" scoped></style>
<template src="./ge-list.html"></template>



// WEBPACK FOOTER //
// ge-list.vue?64a28aff